module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO24IngresosXSalario (55).23ff951.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO24IngresosXSalario (55).mp4
// module id = 750
// module chunks = 1